import axios from "../api/HttpService";
import { authHeader } from '../api/HttpService';
import { setProgramsList } from "../reducers/programReducer";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchProgramsDetails = async (dispatch, type, uniqueNonGuessableId = '') => {
  try {
    const locationQuery = uniqueNonGuessableId
      ? `&uniqueNonGuessableId=${encodeURIComponent(uniqueNonGuessableId)}`
      : '';
    const response = await axios.get(API_URL + `api/programs?type=${type}${locationQuery}`, { headers: authHeader() });
	const programs = response.data?.data?.map(({ id, attributes: { name, description, image, order, link, tooltip, title } }) => ({
		  id,
		  name,
		  description,
		  image: image?.data?.attributes?.formats?.thumbnail?.url || image?.data?.attributes?.url,
		  order,
		  link,
		  tooltip,
		  title
	  }))
	  dispatch(setProgramsList(programs));
  } catch (error) {
	console.log('error', error)
  }
};

export const fetchRetireePrograms = async (dispatch, retireeId) => {
  if (!retireeId) return;
  
  try {
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    
    const response = await fetch(`${API_URL}api/retiree/${retireeId}/programs`, requestOptions);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    
    // Transform the data to match the expected format
    const transformedPrograms = result.data?.map(program => ({
      id: program.id,
      name: program.name,
      description: program.description,
      image: program.image,
      retireeImage: program.retireeImage,
      order: program.order,
      link: program.link,
      tooltip: program.tooltip,
      title: program.title
    })) || [];
    
    dispatch(setProgramsList(transformedPrograms));
  } catch (error) {
    console.error("Error fetching retiree programs:", error);
  }
};

